import SelfRegistration from "../components/SelfRegistration";
import { connect } from "react-redux";
import { actions } from "../reducers/registration";
import { withRouter } from "react-router";

export default withRouter(
  connect(
    state => ({
      validateTokenProcessing:
        state.registration.selfRegistrationStatus.isLoading,

      validateTokenResult: state.registration.validationTokenResponse,
      invValidationResult: state.registration.invValidationResponse,
      registerUserResult: state.registration.registerUserResponse,

      error: state.registration.selfRegistrationStatus.error,
      errorCode: state.registration.selfRegistrationStatus.code
    }),
    // Inject all actions into the component
    actions
  )(SelfRegistration)
);
